import { Record } from 'immutable';

const AgencyConfigLookupRecord = Record({
  agencyId: null,
});

export class AgencyConfigLookup extends AgencyConfigLookupRecord {
  agencyId: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/config/agency-config-lookup.ts